/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import { Modal } from 'react-bootstrap';
import BasePage from '../../../../shared/BasePage';

class FileView extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            imgLoaddingStatus: false
        }
    }

    componentWillReceiveProps(nextProps){
        if (this.props.questionId !== nextProps.questionId)
            this.setState({ imgLoaddingStatus: true});
    }

    componentDidMount(){
        this.setState({ imgLoaddingStatus: true});
    }

    handleImageLoaded() {
        const { questionId, isShowFileloading } = this.props;
        if (isShowFileloading && isShowFileloading[questionId]) {
            this.setState({ imgLoaddingStatus: true});
        } else {
            this.setState({ imgLoaddingStatus: false});
        }
        
    }

    handleImageErrored() {
        this.setState({ imgLoaddingStatus: true});
    }

    render() {
        const { imgLoaddingStatus } = this.state;
        const { isFileView, closeModal, i18n, flieUploadInfo, questionId, fileViewtitle } = this.props;
        // const style = {
        //     width:'0',
        //     height:'0',
        //     scrolling: "no",
        //     marginwidth: "0",
        //     marginheight: "0",
        //     frameborder: "0"
        // }
        const ispdf = flieUploadInfo.viewImage && flieUploadInfo.viewImage[questionId] && flieUploadInfo.viewImage[questionId].isPDF;
        return(
            <div>
            {
                !ispdf &&
                <Modal show={isFileView} onHide={closeModal} className={"file-view"}>
                    <Modal.Header closeButton>
                        <Modal.Title><div data-key="i18n.fileUploadInfo.fileViewTitle">{i18n.fileUploadInfo.fileViewTitle}</div></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="images-views">
                            <h4>{fileViewtitle}</h4>
                            <div className="images-views-main">
                                { 
                                    <img
                                        style={{ display: !imgLoaddingStatus ? 'block' : 'none' }}
                                        onLoad={this.handleImageLoaded.bind(this)}
                                        onError={this.handleImageErrored.bind(this)}
                                        src={flieUploadInfo.viewImage[questionId] && flieUploadInfo.viewImage[questionId].src}
                                        alt={fileViewtitle}
                                    />
                                } 
                                {   
                                    imgLoaddingStatus && (!ispdf) &&
                                    <div className="images-views-txts">
                                        <h2 data-key="i18n.fileUploadInfo.fileUploading">{i18n.fileUploadInfo.fileUploading}</h2>
                                        <p data-key="i18n.fileUploadInfo.fileUploadTxts">{i18n.fileUploadInfo.fileUploadTxts}</p>
                                    </div>
                                }
                                
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            }
            </div>
        );
    }
};

export default FileView;


// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/components/child/FileView.js